module.exports = __webpack_public_path__ + "img/yyLogo.c4607669.png";